<div class="center">
    <p *ngIf="!isLinked"
    >{{ ('Click the button below and follow the instructions to link {}' | translate).replace('{}', 'Google Calendar') }}</p>
    <button
            (click)="clickHandler()"
            [disabled]="isLinked"
            mat-stroked-button
    >
        {{ ( isLinked ? "Connected" : "Link Google Calendar" ) | translate }}
    </button>
</div>